import * as React from 'react';

import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

import { Icon, ICON_NAME } from 'components/icon';
import { translate } from 'components/translate-hoc';
import { ITranslationProps } from 'types/translation';

import {
    ERROR_PAGE_TEXTS,
    ERROR_PAGE_TEXTS_BY_ERROR_TYPE,
    ERROR_TYPE,
    GET_ANALYTICS_ERROR_INIT_DATA
} from './error-page.constants';
import { IErrorPageProps } from './error-page.types';

import './error-page.styles.less';
import { getModeClass } from 'utils/css';

export function ErrorPage({
    dangerouslyTranslateWithHTML: translateKey,
    platform,
    shouldInheritStyles,
    type
}: ITranslationProps & IErrorPageProps): JSX.Element {
    const errorType: ERROR_TYPE = type || ERROR_TYPE.GENERIC;
    const title: string = translateKey(ERROR_PAGE_TEXTS_BY_ERROR_TYPE[errorType].TITLE);
    const description: string = translateKey(ERROR_PAGE_TEXTS_BY_ERROR_TYPE[errorType].DESCRIPTION, { platform });
    const basePageStyleClass = getModeClass('sitegen-fr-error-page', shouldInheritStyles);

    React.useEffect(() => {
        AnalyticsService.sendFlowEvent(GET_ANALYTICS_ERROR_INIT_DATA(errorType));
    }, []);

    return (
        <div className={basePageStyleClass}>
            <div className={`${basePageStyleClass}__caption`}>
                {translateKey(ERROR_PAGE_TEXTS.CAPTION)}
            </div>
            <div className={`${basePageStyleClass}__title`}>
                {translateKey(ERROR_PAGE_TEXTS.TITLE)}
            </div>

            <div className={`${basePageStyleClass}__content`}>
                <Icon name={ICON_NAME.WARNING} />

                <div className={`${basePageStyleClass}__content-title`}>
                    {title}
                </div>
                <div className={`${basePageStyleClass}__content-description`}>
                    {description}
                </div>
            </div>
        </div>
    );
}

export const ErrorPageWithTranslations = translate()(ErrorPage);
